import React, { useEffect, useState } from "react";
import { fetchReportInteractions } from "../../../services/httpClient";
import DataTable from "../ui/DataTable";
import { Card, Row, Spinner } from "react-bootstrap";

interface InteractionsStaleTableState {
  data?: any[];
}

export const InteractionsStaleTable = ({ data }: InteractionsStaleTableState): React.JSX.Element | null => {
  const [tableData, setTableData] = useState<any[]>();

  const tableHeaders = [
    { label: "Case ID", key: "case_id", hide: true },
    { label: "Case Name", key: "case_name" },
    { label: "Person", key: "creator_name" },
    { label: "Most Recent Interaction", key: "most_recent_date" },
  ];

  useEffect(() => {
    const fetchData = async () => {
      if (data) {
        setTableData(data);
      } else {
        await getInteractions();
      }
    };

    fetchData();
  }, [data]);

  const getInteractions = async () => {
    fetchReportInteractions()
      .then(async (res: any) => {
        const data = res[0].data || {};
        setTableData(data.stale_cases);
      })
      .catch((err: any) => {
        console.log(err);
      });
  };

  return tableData ? (
    <DataTable tableHeadings={tableHeaders} tableData={tableData} title={"No Case Interactions in Past Week"} />
  ) : (
    <Card className="p-3">
      <Card.Body>
        <Row className="text-center">
          <text className="mt-2 mb-2">
            <Spinner animation="border" style={{ color: "#F6893D" }} />
          </text>
        </Row>
      </Card.Body>
    </Card>
  );
};
